import { render, staticRenderFns } from "./detail copy.vue?vue&type=template&id=1e3501f8&scoped=true&"
import script from "./detail copy.vue?vue&type=script&lang=js&"
export * from "./detail copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3501f8",
  null
  
)

export default component.exports